import { camelizeKeys } from 'humps';
import unconventional from 'api/uncoventional-keys';

export const camelizeApiResponseFragment = data => {
  return camelizeKeys(data, (key, convert) => unconventional[key] || convert(key));
};



// WEBPACK FOOTER //
// ./src/utils/humps.js